<template>
  <div class="container page">
    <van-nav-bar :title="$t('ui.wallet.title')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <div class="add-card" @click="toBindCard()" v-if="!is_bind">
        <van-icon name="plus" />
        <span>{{ $t('ui.wallet.add') }}</span>
      </div>
      <div class="bank" v-else>
          <div class="info" v-if="isItalianBankBind">
            <div class="row-content">{{ $t('ui.wallet.bank_name_label') }}{{ bankInfo.username }}</div>
            <div class="row-content">{{ $t('ui.wallet.iban_label') }}{{ bankInfo.bankid }}</div>
            <div class="row-content">{{ $t('ui.wallet.mbway_label') }}{{ bankInfo.fhnumber }}</div>
          </div>
          <div class="info" v-else-if="isBankBind">
            <div class="row-content">{{ $t('ui.wallet.bank_name_label') }}{{ bankInfo.username }}</div>
            <div class="row-content">{{ $t('ui.wallet.bank_org_label') }}{{ bankInfo.bankfenhang }}</div>
            <div class="row-content">{{ $t('ui.wallet.card_number_label') }}{{ bankInfo.bankid }}</div>
          </div>
          <div class="info" v-else>
            <div class="row-content">{{ $t('ui.wallet.asset_label') }}{{ bankInfo.bankinfo || 'USDT' }}</div>
            <div class="row-content">{{ $t('ui.wallet.network_label') }}{{ bankInfo.bankfenhang || bankInfo.fhnumber || 'USDT' }}</div>
            <div class="row-content">{{ $t('ui.wallet.address_label') }}{{ bankInfo.bankid }}</div>
          </div>
      </div>
      <div class="tips">{{ $t('ui.wallet.withdraw_confirm_tip') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind:false,
      bankInfo:{},
      userInfo:{}
    };
  },
  computed: {
    isBankBind() {
      return String(this.bankInfo.bankinfo || '').toUpperCase() === 'BANK';
    },
    // 意大利绑定：分支字段固定为 Bank，且有 MBway
    isItalianBankBind() {
      if (!this.isBankBind) {
        return false;
      }
      const branch = String(this.bankInfo.bankfenhang || '').trim().toUpperCase();
      const mbway = String(this.bankInfo.fhnumber || '').trim();
      return branch === 'BANK' && !!mbway;
    }
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.bankInfo = res.data.info;
          }else {
            this.is_bind = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    toBindCard() {
      if (!this.userInfo.name) {
        this.$router.push("Setname");
        this.$toast(this.$t("setting.set_name_bank"));
        return true;
      } else if (!this.userInfo.paypassword) {
        
        // this.$router.push("SetPayPassword");
        this.$router.push({path:'/BindCard'})
        // this.$toast(this.$t("setting.set_pwd_bank"));
        return true;
      } else {
        this.$router.push({path:'/BindCard'})
      }
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 35px;
  line-height: 80px;
}

.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}
.manage-card .wrapper{
  height: calc(100% - 10px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.wrapper .add-card{
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  background-color: #fff;
  height: 250px;
}
.wrapper .add-card span{
  margin-left: 10px;
  font-size: 30px;
}
.wrapper .tips {
  margin: 15px 15px;
  font-size: 25px;
  color: #979799;
}
.wrapper .bank .info {
  margin-left: 20px;
  flex: 1;
  color: #000;
}
.wrapper .bank .info .row-content{
  margin: 30px 0;
  line-height: 20px;
  font-size: 30px;
}
</style>
